// src/modules/app-views/_apps/appmulti/receivables/pages/Document/actions/dropdownMenu.js
import { MoreOutlined } from '@ant-design/icons';
import {
  dropdownArchive,
  dropdownDivider,
  dropdownDuplicate,
  dropdownNew,
  dropdownRemove,
  dropdownRemovePermanently,
  dropdownRestore,
} from 'layouts/Pages/PageHeader/dropdownMenus';

const receivablesDocumentDropdownMenu = () => {
  return {
    action: 'dropdownMenu',
    icon: <MoreOutlined />,
    tooltip: 'more_options',
    dropdownItems: [
      dropdownNew,
      dropdownDuplicate,
      dropdownDivider,
      dropdownArchive,
      dropdownRemove,
      dropdownRestore,
      dropdownRemovePermanently,
    ],
  };
};

export default receivablesDocumentDropdownMenu;
